import "./App.css";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./Components/Home";
import About from "./Components/About";
import Work from "./Components/Work";
import Footer from "./Components/Footer";
import Downloads from "./Components/Downloads";
import JoinWallet from "./Components/JoinWallet";

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/downloads" element={<Downloads />} />
          <Route path="/join/:token" element={<JoinWallet />} />
          <Route path="/" element={
            <>
              <Home />
              <About />
              <Work />
              {/* <Testimonial /> */}
              {/* <Contact /> */}
              <Footer />
            </>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
